import { authenticationService } from './mapbox-client';
import browserHistory from '../browser-history';
import config from '../config';
import hasActiveAtlasLicense from './has-active-atlas-license';

function banish() {
  window.location.assign(
    `${config.MAPBOX_ACCOUNT_URL_ORIGIN}/auth/signin/?route-to="${config.MAPBOX_ATLAS_ENDPOINT}"`
  );
}

function redirectToContactSales() {
  browserHistory.push('/contact-sales');
}

export default function loadUser() {
  return authenticationService
    .getSession()
    .send()
    .then(
      response => {
        const authenticatedUser = response.body;
        // If the user has neither a valid atlasv2 nor atlasv3 license,
        // direct them to the contact sales page
        if (!hasActiveAtlasLicense(authenticatedUser)) {
          redirectToContactSales();
        }
        return authenticatedUser;
      },
      error => {
        if (error.statusCode === 403) {
          banish();
        } else {
          throw error;
        }
      }
    );
}
